import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateAxios, publicAxios } from "../axiosInstances";
import { emailsConsentsQueryKeys } from "../query-keys/emails-consents.query-keys";

type UpsertConsent = {
  emails: string[];
  hasConsented: boolean;
};

const upsertConsent = async (content: UpsertConsent) => {
  const { data } = await privateAxios.patch(`/email-consents`, content);
  return data;
};

export const useUpdateEmailConsent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (content: UpsertConsent) => upsertConsent(content),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: emailsConsentsQueryKeys.all,
      });
    },
  });
};

const deleteConsent = async (id: string) => {
  const { data } = await privateAxios.delete(`/email-consents/${id}`);
  return data;
};

export const useDeleteEmailConsent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteConsent(id),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: emailsConsentsQueryKeys.all,
      });
    },
  });
};

type RefuseConsent = {
  emails: string[];
  isFromWebApp?: boolean;
  reason?: string;
};

const refuseConsent = async (content: RefuseConsent) => {
  const { data } = await publicAxios.post(`/email-consents/refuse`, content);
  return data;
};

export const useRefuseEmailConsent = () => {
  return useMutation({
    mutationFn: (content: RefuseConsent) => refuseConsent(content),
  });
};
